module.exports = __webpack_public_path__ + "img/interview-planning.db1e4e5f.png";